import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Connect from '../../components/News/News'
import client from '../../Services/client'

class ConnectList extends Component {

    state = {
        news: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getNews()
    }
    getNews = () => {
        client.getEntries({
            content_type: 'connect',
            query: this.state.searchString
        })
        .then((response) => {
            this.setState({news: response.items})
            console.log(this.state.news)
        })
        .catch((error) => {
          console.log("Error occurred while fetching Entries")
          console.error(error)
        })
    }
    onSearchInputChange = (event) => {
        console.log("Search changed ..." + event.target.value)
        if (event.target.value) {
            this.setState({searchString: event.target.value})
        } else {
            this.setState({searchString: ''})
        }
        this.getNews()
    }
    render() {
        return (
            <main className="listing-page">
                { this.state.news ? (
                    <div>
                        <div className="listing-header">
                            <div>
                                <span className="listing-eyebrow">Insights & ideas</span>
                                <h1>Articles</h1>
                            </div>
                        <TextField className="listing-search"
                            id="searchInput"
                            placeholder="Search for Articles"   
                            margin="normal"
                            onChange={this.onSearchInputChange}
                            />
                        </div>
                        <Grid container spacing={3} className="listing-grid">
                            { this.state.news.map(currentNews => (
                               <Grid item xs={12} sm={6} md={4} lg={3} key={currentNews.sys.id}>
                                    <Connect news={currentNews} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ) : "No News found" }
            </main>
        )
    }
}

export default ConnectList;


// WEBPACK FOOTER //
// ./src/components/News/NewsList.js